/**
 * @generated SignedSource<<fea64d335619dc8b112c97eee2141a8a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CastVoteInputQueryFragment$data = {
  readonly delegate?: {
    readonly statement: {
      readonly statement: string;
      readonly topIssues: ReadonlyArray<{
        readonly type: string;
        readonly value: string;
      }>;
    } | null;
  };
  readonly " $fragmentType": "CastVoteInputQueryFragment";
};
export type CastVoteInputQueryFragment$key = {
  readonly " $data"?: CastVoteInputQueryFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"CastVoteInputQueryFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "address"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "skipAddress"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "CastVoteInputQueryFragment",
  "selections": [
    {
      "condition": "skipAddress",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "addressOrEnsName",
              "variableName": "address"
            }
          ],
          "concreteType": "Delegate",
          "kind": "LinkedField",
          "name": "delegate",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "DelegateStatement",
              "kind": "LinkedField",
              "name": "statement",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "statement",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "TopIssue",
                  "kind": "LinkedField",
                  "name": "topIssues",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "type",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "value",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "e4da37cecab6d9616fef5c1e803e6330";

export default node;
